import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionQuery } from '../../_core/state/session';
import { isValidOAuthAuthorizationTransaction } from './oauth-authorization-browser.service';

export const oauthAuthorizationGuard: CanActivateFn = route => {
	const transaction = route.paramMap.get('transaction');
	if (!isValidOAuthAuthorizationTransaction(transaction)) {
		// Let the component render its non-authenticated, non-disclosing invalid
		// request state instead of sending a malformed value through login.
		return true;
	}

	const sessionQuery = inject(SessionQuery);

	if (sessionQuery.isLoggedIn()) {
		return true;
	}

	return inject(Router).createUrlTree(['/login'], {
		queryParams: { redirect: `/oauth/authorize/${encodeURIComponent(transaction)}` }
	});
};
